import React from 'react'
import ReactMarkdown from 'react-markdown'
import { injectIntl, intlShape } from 'react-intl'
import Helmet from 'react-helmet';

import './ContentBlocks.css'

const FullbleedHero = (props) => (
  <div className="fullbleed hero" style={{backgroundImage: 'url('+(props.fields.image.fields.file ? props.fields.image.fields.file.url+'?fm=jpg&q=80)' : '')}}>
    <Helmet
      meta={[
        {"name": "description", "content": props.fields.lead},
        {"property": "og:description", "content": props.fields.lead}
      ]}
    />
    <div className="container">
      <div>
        {props.fields.heading && <h1>{props.fields.heading}</h1>}

        <div className="lead">
          {props.fields.lead && <ReactMarkdown source={props.fields.lead} softBreak="br" />}
        </div>
      </div>
    </div>
  </div>
)

FullbleedHero.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(FullbleedHero)


// WEBPACK FOOTER //
// ./src/components/ContentBlocks/FullbleedHero.js